import { render } from "./LoginView.vue?vue&type=template&id=68e0897a&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=68e0897a&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e0897a"]])

export default __exports__